import applicationSettings from 'translations/fr/administration/applicationSettings'
import attributes from 'translations/fr/administration/attributes'
import breaks from 'translations/fr/administration/breaks'
import config from 'translations/fr/administration/config'
import departments from 'translations/fr/administration/departments'
import hiringData from 'translations/fr/administration/hiringData'
import holidays from 'translations/fr/administration/holidays'
import wagePremiums from 'translations/fr/administration/wagePremiums'
import permissions from 'translations/fr/administration/permissions'
import positions from 'translations/fr/administration/positions'
import punchRules from 'translations/fr/administration/punchRules'
import recurringJobsTests from 'translations/fr/administration/recurringJobsTests'
import requestOptions from 'translations/fr/administration/requestOptions'
import scheduleTypes from 'translations/fr/administration/scheduleTypes'
import structure from 'translations/fr/administration/structure'
import tags from 'translations/fr/administration/tags'
import teams from 'translations/fr/administration/teams'

export default {
  APPLICATION_SETTINGS: `Paramètres de l'application`,
  ATTRIBUTES: `Attributs`,
  BILLING: `Facturation`,
  BREAKS: `Pauses`,
  BREAKS_RULES: `Pauses (règles)`,
  CODE: {
    LABEL: `Code d'importation`,
    PLACEHOLDER: `Entrer un code`,
    DESCRIPTION: "Ce code d'importation sert à pouvoir assigner des {{resources}} à d'autres ressources avec les outils d'importation."
  },
  IMPORTCODE: {
    LABEL: `Code d'importation`,
    PLACEHOLDER: `Entrer un code`
  },
  POSITIONCODE: {
    LABEL: `Code d'importation`,
    PLACEHOLDER: `Entrer un code`
  },
  DEPARTMENTS: `Départments`,
  FILTER_SORTS: `Filtre et classement`,
  HIRING_DATA: `Données d'embauche`,
  IMPORT: `Importation`,
  WAGEPREMIUM: `Codes de prime`,
  PERMISSIONS: `Permissions`,
  POSITIONS: `Positions`,
  PUNCH_RULES: `Règles des cartes de temps`,
  REQUEST_OPTIONS: `Types de requête`,
  SCHEDULE_TYPES: `Types d'horaires`,
  STRUCTURE: `Structure`,
  TAGS: `Étiquettes`,
  TEAMS: `Équipes`,
  HOLIDAYS: `Jours fériés`,
  ENTER_USERNAME_CONFIRM_DELETE: `Veuillez entrer votre nom d'utilisateur afin de confirmer la suppression :`,
  ENTER_USERNAME_PLACEHOLDER: `Entrez votre nom d'utilisateur`,
  SEE_COLUMNS: `Voir ces colonnes`,
  SORT_BY: `Ordonner par`,
  CONFIG_DEFAULT: `Filtres par défaut`,
  CONFIG_FILTER: `Filtres`,
  CONFIG_LISTS: `Types de listes`,
  CONFIG_PROCEDURE: `Procédures de listes`,
  CONFIG_SORT: `Classements`,
  PERMISSIONS_ACCESS: `Permissions de la compagnie`,
  VALID_IMPORT_CODE: `Le code d'importation ne peut contenir que des lettres, chiffres, des tirets ( - ) ou des tirets-bas ( _ ), et pas d'espaces.`,
  TESTS: `Tests`,
  groupNames: {
    CONFIGURATION: `Configuration`,
    TIME_PAY: `Temps et présence`,
    PEOPLE: `Employés`,
    SCHEDULE: `Horaire`
  },
  confirmDeletion: {
    ERROR_DELETING: `Il y a eu une erreur pendant la suppression.`,
    ERROR_LOADING: `Erreur en chargeant les éléments impactés.`,
    BAD_USERNAME_CONFIRMATION: `Doit correspondre à votre nom d'utilisateur`,
    USERNAME_IS_REQUIRED: `Votre nom d'utilisateur est requis`,
    WILL_BE_IMPACTED: `<h6>Cette action aura les conséquences suivantes (resources supprimées ou réassignées).</h6><h6>Veuillez cocher les cases ci-dessous pour confirmer en avoir pris connaissance:</h6>`,
    AFFECTED_TEAMS: `<0>Équipes impactées:</0> {{ count }}`,
    AFFECTED_LOCATIONS: `<0>Emplacements impactés:</0> {{ count }}`,
    AFFECTED_PROJECTS: `<0>Projets impactés:</0> {{ count }}`,
    AFFECTED_STRUCTURES: `<0>Positions impactées:</0> {{ count }}`,
    AFFECTED_PUNCHCARDS: `<0>Cartes de temps impactées:</0> {{ count }}`,
    AFFECTED_SHIFTS: `<0>Quarts de travail impactés:</0> {{ count }}`,
    AFFECTED_EVENTS: `<0>Quarts de travail impactés:</0> {{ count }}`,
    AFFECTED_TEMPLATEEVENTS: `<0>Quarts de travail dans les modèles d'horaire impactés:</0> {{ count }}`,
    AFFECTED_TEMPLATES: `<0>Modèles d'horaire impactés:</0> {{ count }}`,
    AFFECTED_USERS: `<0>Utilisateurs impactés:</0> {{ count }}`,
    WARNING: `<0>Avertissement:</0> Cette opération est <0>irréversible</0>.`
  },
  ARCHIVE_BUTTON: {
    BAD_MATCH: `La saisie ne correspond pas au mot "ARCHIVER"`,
    FIELD_IS_REQUIRED: `Ce champ est requis`,
    CONFIRM: {
      LABEL: `Entrez "ARCHIVER" pour confirmer`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  DELETE_BUTTON: {
    BAD_MATCH: `La saisie ne correspond pas au mot "SUPPRIMER"`,
    FIELD_IS_REQUIRED: `Ce champ est requis`,
    CONFIRM: {
      LABEL: `Entrez "SUPPRIMER" pour confirmer`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  applicationSettings,
  attributes,
  breaks,
  config,
  departments,
  hiringData,
  holidays,
  wagePremiums,
  permissions,
  positions,
  punchRules,
  recurringJobsTests,
  requestOptions,
  scheduleTypes,
  structure,
  tags,
  teams
}
